export const meetingsFr = {
  title: "Réunions",
  add_button: "Ajouter des notes Granola",
  badge: "%{smart_count} note à associer |||| %{smart_count} notes à associer",
  tabs: { unmatched: "À associer", matched: "Associées", internal: "Internes" },
  empty: {
    unmatched: "Aucune note à associer.",
    matched: "Aucune note associée ces 30 derniers jours.",
    internal: "Aucune réunion interne.",
  },
  paste: {
    title: "Ajouter des notes Granola",
    help: "Dans Granola, ouvrez la note, cliquez sur « Copier », puis collez le texte ici.",
    text_label: "Notes Granola",
    text_placeholder: "Collez ici les notes copiées depuis Granola…",
    chars: "%{count} / %{max} caractères",
    title_label: "Titre de la réunion",
    started_at_label: "Date et heure de la réunion",
    share_url_label: "Lien de partage Granola (facultatif)",
    target_label: "Compagnie",
    deal_label: "Deal (facultatif)",
    no_results: "Aucun résultat",
    no_deal: "Aucun deal",
    preview_items:
      "%{smart_count} action détectée |||| %{smart_count} actions détectées",
    transcript_removed:
      "La transcription a été retirée : seules les notes sont conservées.",
    save: "Enregistrer",
    cancel: "Annuler",
    saved: "Notes Granola ajoutées.",
    duplicate: "Ces notes ont déjà été ajoutées.",
  },
  card: {
    granola: "Notes Granola",
    granola_call: "🎙️ Granola", // GAVION granola-calls
    spans_calls: "Cette note couvre peut-être plusieurs appels.",
    show_more: "Afficher tout",
    show_less: "Réduire",
    open_granola: "Ouvrir dans Granola",
    demo_held: "Démo tenue",
    attendees: "Participants",
    section_title: "Notes de réunion",
    none: "Aucune note de réunion.",
  },
  tasks: {
    title: "Tâches suggérées",
    create: "Créer les tâches sélectionnées",
    created: "%{smart_count} tâche créée |||| %{smart_count} tâches créées",
    none_selected: "Sélectionnez au moins une tâche.",
    due: "Échéance : %{date}",
  },
  inbox: {
    associate: "Associer à…",
    ignore: "Ignorer",
    associate_title: "Associer la note",
    save: "Associer",
    associated: "Note associée.",
    ignored: "Note ignorée.",
    restore: "Restaurer",
    restored: "Note restaurée.",
    suggest: "Associer à %{name} ?",
    suggested: "Note associée à %{name}.",
    reasons: {
      booked_demo: "démo réservée à %{time}",
      phone: "numéro de la compagnie",
      attendee: "courriel du participant",
      title: "nom dans le titre",
    },
  },
  errors: {
    empty_note: "Collez les notes avant d'enregistrer.",
    note_too_large: "Texte trop long (maximum 50 000 caractères).",
    started_at_required: "Indiquez la date de la réunion.",
    future_date: "La date de la réunion ne peut pas être dans le futur.",
    company_not_found: "Compagnie introuvable.",
    deal_not_found: "Deal introuvable.",
    deal_company_mismatch: "Ce deal n'appartient pas à cette compagnie.",
    contact_company_mismatch: "Ce contact n'appartient pas à cette compagnie.",
    invalid_share_url: "Lien Granola invalide (https://notes.granola.ai/…).",
    invalid_attendees: "Liste de participants invalide.",
    not_found: "Note introuvable.",
    note_not_matched: "Associez d'abord la note à une compagnie.",
    too_many_items: "20 tâches au maximum à la fois.",
    forbidden: "Action non autorisée.",
    unknown: "Une erreur est survenue. Réessayez.",
  },
};
